import { render, staticRenderFns } from "./RomaPoll.vue?vue&type=template&id=f038fce2&scoped=true&"
import script from "./RomaPoll.vue?vue&type=script&lang=js&"
export * from "./RomaPoll.vue?vue&type=script&lang=js&"
import style0 from "./RomaPoll.vue?vue&type=style&index=0&id=f038fce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f038fce2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
